import {createSvgIcon} from '../create-svg-icon';

export const ShowChartIcon = createSvgIcon(
  <path d="m3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z" />
, 'ShowChartOutlined');
